<div class="layout-content">
	<!-- ACTIVE TASKS -->
	<div *ngIf="activeTasks.length > 0" class="grid mt-0">
		<div class="col-12 pt-0">
			<div class="flex justify-content-center">
				<div class="flex font-semibold text-lg">{{ 'ACTIVE_TASK' | translate }}</div>
			</div>
		</div>
		<div class="col-12 pt-0">
			<p-table #tableUserFilesList dataKey="id" [value]="activeTasks" [paginator]="true" [rows]="pageSize"
				[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[autoLayout]="true" sortField="updated_at" [sortOrder]="-1" responsiveLayout="stack" styleClass="surface-400 border-round paginator-grey-color">

				<ng-template pTemplate="header">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'TYPE' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'STATUS' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'UPDATED_AT' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'PROGRESS' | translate }}
							</div>
						</th>
						<th></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-task>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'TYPE' | translate }}</span>{{ getTaskType(task.Type)
							| translate }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'STATUS' | translate }}</span>
							<p-tag [value]="getTaskStatus(task.Status) | translate"
								[severity]="getTaskStatusSeverity(task)"></p-tag>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'UPDATED_AT' | translate }}</span>{{ task.UpdatedAt |
							localizedDate: 'medium' }}
						</td>
						<td *ngIf="!underTablet()">
							<span class="p-column-title font-semibold">{{ 'PROGRESS' | translate }}</span>
							<div id="textTasksCloudAborted" *ngIf="isAbortOrError(task)"
								class="flex flex-row align-items-center text-primary">
								<div class="w-4rem mr-2"></div>
								<p-progressBar [value]="0" class="w-full" [style]="{'height': '6px'}">
									<ng-template pTemplate="content" let-value>
										<span></span>
									</ng-template>
								</p-progressBar>
							</div>
							<div id="textTasksCloudCompleted" *ngIf="isSuccess(task)"
								class="flex flex-row align-items-center text-primary">
								<div class="w-4rem mr-2">100 %</div>
								<p-progressBar [value]="100" class="w-full" [style]="{'height': '6px'}">
									<ng-template pTemplate="content" let-value>
										<span></span>
									</ng-template>
								</p-progressBar>
							</div>
							<div id="textTasksCloudProgress" *ngIf="isRunning(task)"
								class="flex flex-row align-items-center text-primary">
								<div class="w-4rem mr-2">{{ getProgress(task) }} %</div>
								<p-progressBar mode="indeterminate" class="w-full" [style]="{'height': '6px'}" />
							</div>
						</td>
						<td *ngIf="underTablet()">
							<div id="textTasksCloudAborted" *ngIf="isAbortOrError(task)"
								class="flex flex-row align-items-center text-primary w-full">
								<div class="w-5rem mr-2"></div>
								<p-progressBar [value]="0" class="w-full" [style]="{'height': '6px'}">
									<ng-template pTemplate="content" let-value>
										<span></span>
									</ng-template>
								</p-progressBar>
							</div>
							<div id="textTasksCloudCompleted" *ngIf="isSuccess(task)"
								class="flex flex-row align-items-center text-primary w-full">
								<div class="w-5rem mr-2">100 %</div>
								<p-progressBar [value]="100" class="w-full" [style]="{'height': '6px'}">
									<ng-template pTemplate="content" let-value>
										<span></span>
									</ng-template>
								</p-progressBar>
							</div>
							<div id="textTasksCloudProgress" *ngIf="isRunning(task)"
								class="flex flex-row align-items-center text-primary w-full">
								<div class="w-5rem mr-2">{{ getProgress(task) }} %</div>
								<p-progressBar mode="indeterminate" class="w-full" [style]="{'height': '6px'}" />
							</div>
							<div id="stopTaskButton" class="w-4rem">
								<p-button pTooltip="{{ 'STOP' | translate }}" [disabled]="!isRunning(task)"
									tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="abortTask(task)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
						<td *ngIf="!underTablet()">
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<!-- <p-button pTooltip="{{ getResult(task) }}" tooltipEvent="focus"
									tooltipPosition="bottom" icon="pi cm-info" size="large"
									[rounded]="false" [text]="true" severity="secondary">
								</p-button> -->
								<p-button pTooltip="{{ 'STOP' | translate }}" [disabled]="!isRunning(task)"
									tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="abortTask(task)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
		<!-- DIVIDER -->
		<div class="col-12">
			<div class="flex border-bottom-2 text-700 py-0 mx-3"></div>
		</div>
	</div>
	<!-- ALL TASKS -->
	<div class="grid mt-0">
		<div *ngIf="activeTasks.length > 0" class="col-12 pt-0">
			<div class="flex justify-content-center">
				<div class="flex font-semibold text-lg">{{ 'ALL_TASKS' | translate }}</div>
			</div>
		</div>
		<div class="col-12 pt-0">
			<p-table #tableUserFilesList dataKey="Id" [value]="tasks" [lazy]="true" (onLazyLoad)="loadTasks($event)"
				[paginator]="true" [totalRecords]="resultLength" [loading]="tasksLoading" [rows]="pageSize"
				[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[autoLayout]="true" sortField="updated_at" [sortOrder]="-1" responsiveLayout="stack">

				<ng-template pTemplate="header">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'TYPE' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'STATUS' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'UPDATED_AT' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'PROGRESS' | translate }}
							</div>
						</th>
						<th></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-task>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'TYPE' | translate }}</span>{{ getTaskType(task.Type)
							| translate }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'STATUS' | translate }}</span>
							<p-tag [value]="getTaskStatus(task.Status) | translate"
								[severity]="getTaskStatusSeverity(task)"></p-tag>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'UPDATED_AT' | translate }}</span>{{ task.UpdatedAt |
							localizedDate: 'medium' }}
						</td>
						<td *ngIf="!underTablet()">
							<span class="p-column-title font-semibold">{{ 'PROGRESS' | translate }}</span>
							<div id="textTasksCloudAborted" *ngIf="isAbortOrError(task)"
								class="flex flex-row align-items-center text-primary">
								<div class="w-4rem mr-2"></div>
								<p-progressBar [value]="0" class="w-full" [style]="{'height': '6px'}">
									<ng-template pTemplate="content" let-value>
										<span></span>
									</ng-template>
								</p-progressBar>
							</div>
							<div id="textTasksCloudCompleted" *ngIf="isSuccess(task)"
								class="flex flex-row align-items-center text-primary">
								<div class="w-4rem mr-2">100 %</div>
								<p-progressBar [value]="100" class="w-full" [style]="{'height': '6px'}">
									<ng-template pTemplate="content" let-value>
										<span></span>
									</ng-template>
								</p-progressBar>
							</div>
							<div id="textTasksCloudProgress" *ngIf="isRunning(task)"
								class="flex flex-row align-items-center text-primary">
								<div class="w-4rem mr-2">{{ getProgress(task) }} %</div>
								<p-progressBar mode="indeterminate" class="w-full" [style]="{'height': '6px'}" />
							</div>
						</td>
						<td *ngIf="underTablet()">
							<div id="textTasksCloudAborted" *ngIf="isAbortOrError(task)"
								class="flex flex-row align-items-center text-primary w-full">
								<div class="w-5rem mr-2"></div>
								<p-progressBar [value]="0" class="w-full" [style]="{'height': '6px'}">
									<ng-template pTemplate="content" let-value>
										<span></span>
									</ng-template>
								</p-progressBar>
							</div>
							<div id="textTasksCloudCompleted" *ngIf="isSuccess(task)"
								class="flex flex-row align-items-center text-primary w-full">
								<div class="w-5rem mr-2">100 %</div>
								<p-progressBar [value]="100" class="w-full" [style]="{'height': '6px'}">
									<ng-template pTemplate="content" let-value>
										<span></span>
									</ng-template>
								</p-progressBar>
							</div>
							<div id="textTasksCloudProgress" *ngIf="isRunning(task)"
								class="flex flex-row align-items-center text-primary w-full">
								<div class="w-5rem mr-2">{{ getProgress(task) }} %</div>
								<p-progressBar mode="indeterminate" class="w-full" [style]="{'height': '6px'}" />
							</div>
							<div id="stopTaskButton" class="w-4rem">
								<p-button pTooltip="{{ 'STOP' | translate }}" [disabled]="!isRunning(task)"
									tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="abortTask(task)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
						<td *ngIf="!underTablet()">
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<!-- <p-button pTooltip="{{ getResult(task) }}" tooltipEvent="focus"
									tooltipPosition="bottom" icon="pi cm-info" size="large"
									[rounded]="false" [text]="true" severity="secondary">
								</p-button> -->
								<p-button pTooltip="{{ 'STOP' | translate }}" [disabled]="!isRunning(task)"
									tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="abortTask(task)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>